export const SENDER_TYPE = {
  USER: 'user',
  AI: 'ai',
} as const;

export type SenderType = (typeof SENDER_TYPE)[keyof typeof SENDER_TYPE];
